var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import apiGateway from '@/api-gateway';
import GoogleMap from '@/components/GoogleMap.vue';
import { formatDate, genProjectName } from '@/utils/string';
import TextInfo from '@/components/TextInfo.vue';
var ProjectPreviewPanel = /** @class */ (function (_super) {
    __extends(ProjectPreviewPanel, _super);
    function ProjectPreviewPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.projectInfo = {};
        _this.fetchedData = false;
        return _this;
    }
    ProjectPreviewPanel.prototype.onIdChanged = function (toId) {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.fetchProjectInfo(toId)];
                    case 1:
                        _a.projectInfo = _b.sent();
                        this.fetchedData = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProjectPreviewPanel.prototype, "mapPosition", {
        get: function () {
            return {
                lng: this.projectInfo.longtitude,
                lat: this.projectInfo.latitude
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "projectName", {
        get: function () {
            return genProjectName(this.projectInfo);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "approvedDate", {
        get: function () {
            return formatDate(this.projectInfo.targetApproveDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "siteHODate", {
        get: function () {
            return formatDate(this.projectInfo.targetHandOverDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "goDate", {
        get: function () {
            return formatDate(this.projectInfo.targetOpenDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "presentSiteDate", {
        get: function () {
            return formatDate(this.projectInfo.targetPresentSiteDate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "firstCIADate", {
        get: function () {
            return formatDate(this.projectInfo.targetFirstCIADate);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectPreviewPanel.prototype, "tpmDate", {
        get: function () {
            return formatDate(this.projectInfo.targetTPMDate);
        },
        enumerable: false,
        configurable: true
    });
    ProjectPreviewPanel.prototype.fetchProjectInfo = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiGateway.getProjectInclude(id.toString(), {
                            ParticularPack: true,
                            format: true,
                            subFormat: true,
                            type: true,
                            regionCode: true,
                            subFormatCode: true
                        })];
                    case 1:
                        resp = _a.sent();
                        return [2 /*return*/, resp.data || {}];
                }
            });
        });
    };
    ProjectPreviewPanel.prototype.goToInfo = function () {
        this.$router.push("/projects/" + this.id + "/view/info");
    };
    __decorate([
        Prop({
            type: Number,
            required: true
        })
    ], ProjectPreviewPanel.prototype, "id", void 0);
    __decorate([
        Watch('id')
    ], ProjectPreviewPanel.prototype, "onIdChanged", null);
    ProjectPreviewPanel = __decorate([
        Component({
            components: {
                GoogleMap: GoogleMap,
                TextInfo: TextInfo
            }
        })
    ], ProjectPreviewPanel);
    return ProjectPreviewPanel;
}(Vue));
export default ProjectPreviewPanel;
